module.exports = __webpack_public_path__ + "img/pic-pubgm.37aaf67.png";